import { Grid, makeStyles, Theme, TableCell, TableRow } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { SemiConfigProductTypes } from '../../enum'
import { ReactNode } from 'react'
import { convertToUppercaseBasedOnCondition } from '../../ProductsConfiguration'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: theme.spacing(6, 10),
  },
  paddingTop: {
    paddingTop: theme.spacing(4),
  },
  label: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightBold,
  },
  value: {
    fontSize: theme.typography.pxToRem(14),
  },
}))

interface TableItem {
  label: ReactNode
  value: string
}
const ExpandedItemSingle = ({
  label,
  value,
  index,
}: TableItem & { index: number }) => {
  const classes = useStyles()
  return (
    <Grid item xs={6} className={index > 1 ? classes.paddingTop : undefined}>
      <Grid container>
        <Grid item xs={4} className={classes.label}>
          {label}
        </Grid>
        <Grid item xs={8} className={classes.value}>
          {value}
        </Grid>
      </Grid>
    </Grid>
  )
}

const TableExpanded = ({
  data,
  product,
}: {
  data: string
  product: string
}) => {
  const classes = useStyles()
  const dataToDisplay = JSON.parse(data)
  let dataList: TableItem[] = []
  if (product === SemiConfigProductTypes.PREDESIGNED_CRISPR_GRNA) {
    dataList = [
      {
        label: (
          <FormattedMessage
            id="SEMICONF_DETAILS_SEQUENCE_crisprgrna"
            defaultMessage="Sequence (5'-3'):"
          />
        ),
        value: dataToDisplay?.targetSequence || '',
      },
      {
        label: (
          <FormattedMessage
            id="SEMICONF_DETAILS_STRAND_crisprgrna"
            defaultMessage="Strand:"
          />
        ),
        value: convertToUppercaseBasedOnCondition(
          dataToDisplay?.senseAntisense || ''
        ),
      },
      {
        label: (
          <FormattedMessage
            id="SEMICONF_DETAILS_PAM_crisprgrna"
            defaultMessage="PAM:"
          />
        ),
        value: convertToUppercaseBasedOnCondition(dataToDisplay?.pam || ''),
      },
      {
        label: (
          <FormattedMessage
            id="SEMICONF_DETAILS_TRANSCRIPTS_HIT_crisprgrna"
            defaultMessage="Transcripts Hit:"
          />
        ),
        value: convertToUppercaseBasedOnCondition(
          dataToDisplay?.transcriptsHit || ''
        ),
      },
      {
        label: (
          <FormattedMessage
            id="SEMICONF_DETAILS_START_COORDINATE_crisprgrna"
            defaultMessage="Start Coordinate:"
          />
        ),
        value: convertToUppercaseBasedOnCondition(
          dataToDisplay?.startCoordinate || ''
        ),
      },
      {
        label: (
          <FormattedMessage
            id="SEMICONF_DETAILS_REFSEQ_crisprgrna"
            defaultMessage="Refseq/Exon:"
          />
        ),
        value: convertToUppercaseBasedOnCondition(
          dataToDisplay?.refSeqId && Array.isArray(dataToDisplay?.refSeqId)
            ? dataToDisplay?.refSeqId[0]
            : ''
        ),
      },
      {
        label: (
          <FormattedMessage
            id="SEMICONF_DETAILS_CHROMOSOME_crisprgrna"
            defaultMessage="Chromosome:"
          />
        ),
        value: convertToUppercaseBasedOnCondition(
          dataToDisplay?.chromosome || ''
        ),
      },
    ]
  }
  return (
    <TableRow style={{ backgroundColor: '#F8F8FC' }}>
      <TableCell colSpan={9}>
        <Grid container xs={12} className={classes.container}>
          {dataList.map((listItem, index) => (
            <ExpandedItemSingle
              key={index}
              label={listItem.label}
              value={listItem.value}
              index={index}
            />
          ))}
        </Grid>
      </TableCell>
    </TableRow>
  )
}

export default TableExpanded
